module.exports = __webpack_public_path__ + "static/media/grease-3.c69162da.png";